import type { RouterScrollBehavior } from "vue-router";

// https://router.vuejs.org/api/#routeroptions
const scrollBehavior: RouterScrollBehavior = function (to, from) {
  if (to.hash) {
    return { el: decodeURIComponent(to.hash), top: 100, behavior: "smooth" };
  }
  if (to.path === from.path) {
    return {};
  }
  return { top: 0 };
};

export default {
  scrollBehavior,
};
